import React, { useEffect } from "react";

// utils
import { useScriptConverter } from "../utils/languageHelpers";
import { SERVER, MYBESTUSER, CLIENTID } from "../config/environment";

const DevMode = () => {
  const converter = useScriptConverter();

  // Check if using dev server
  const isDevServer = SERVER?.includes("dev.");

  useEffect(() => {
    // Removed toast notification for production builds
  }, []);

  if (process.env.NODE_ENV === "production" && !isDevServer) return null;

  return (
    <div
      style={{
        width: "100vw",
        minHeight: "100vh",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        pointerEvents: "none",
        position: "fixed",
        alignItems: "center",
        zIndex: 10000000
      }}
    >
      <span
        style={{
          color: "red",
          fontSize: 50,
          marginTop: 5
        }}
      >
        {converter({ en: "DEV ver.", tw: "開發中版本", cn: "开發中版本" })}
      </span>
    </div>
  );
};

export default DevMode;
